import { Component, OnInit } from '@angular/core';
import { WeblinkUserService } from '../shared/weblink-user.service';

@Component({
  selector: 'app-weblink-login',
  templateUrl: './weblink-login.component.html',
  styleUrls: ['./weblink-login.component.scss']
})
export class WeblinkLoginComponent implements OnInit {

  constructor(private userService: WeblinkUserService) { }


  user:string;

  ngOnInit() {
    this.user= this.userService.getCurrentUser();
  }

  login(){
    this.userService.setCurrentUser(this.user);
  }



}
